import { render, staticRenderFns } from "./OfferStacked.vue?vue&type=template&id=1a480b60&scoped=true&"
import script from "./OfferStacked.vue?vue&type=script&lang=js&"
export * from "./OfferStacked.vue?vue&type=script&lang=js&"
import style0 from "./OfferStacked.vue?vue&type=style&index=0&id=1a480b60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a480b60",
  null
  
)

export default component.exports